import { Component, OnInit } from '@angular/core';
import { GridBaseCase } from '../grid/grid.base.case';

@Component({
  selector: 'app-grid-calendar',
  templateUrl: './grid-calendar.component.html',
  styleUrls: ['./grid-calendar.component.scss']
})
export class GridCalendarComponent extends GridBaseCase {

  constructor() { super();
  }

}
